import { createApp } from 'vue'
import App from './App.vue'
import naive from 'naive-ui'
import router from './router'
// 黑金主题（与扩展弹窗同源）
import './assets/theme.css'
// 通用字体
import 'vfonts/Lato.css'
// 等宽字体
import 'vfonts/FiraCode.css'
import SignalRClient from './ts/SignalRClient'

// 先挂载 Vue 应用，SignalR 后台连接，避免服务不可用时白屏
const app = createApp(App);
app.use(naive);
app.use(router);
app.mount('#app');

SignalRClient.Instance.StartAsync().catch(() => {
    console.warn('SignalR 连接失败，将在页面内重试');
});


